module.exports = __webpack_public_path__ + "img/banner-03.bbc1bcb9.jpg";